import React from 'react';

import { Trans } from "react-i18next";

import {
  Callout,
  Button,
  Tag,
  Dialog,
  Classes,
  FormGroup,
  Checkbox,
  InputGroup,
  MenuItem,
  OverlayToaster,
  Position,
  Collapse,
  Spinner,
} from '@blueprintjs/core';

import {
  bonitickAuthenticatedPatchFetch,
  bonitickAuthenticatedDeleteFetch,
  bonitickAuthenticatedPostFetchWithResult,
  bonitickAuthenticatedPutFetch
} from '../../utils/BonitickAuthenticatedFetch';
import {
  getVendorLookup,
  getProfilLookup
} from './lookup';
import { MultiSelect } from '@blueprintjs/select';
import i18n from 'i18next';


export class Vendor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      vendors: props.vendors,
      profils: props.profils,
      users: [],
      isOpen: [],
      creating: false,
      editing: -1,
      editing_user: -1,
      input_name: "",
      input_email: "",
      input_parks: [],
      input_store: "",
      input_secretcode: "",
      input_active: true,
      input_isadmin: false,
      input_password: "",
      input_date_expiration: "",
      input_discounts: [],
      input_profils: [],

      // user
      creating_user: false,
      creating_vendor_id: -1,
      input_user_login: "",
      input_user_date_expiration: "",
      input_user_active: true,
      input_user_vendorId: true,
    };
  }

  disableCreateVendorButton() {
    const { input_name, input_email, input_date_expiration, input_secretcode, input_password, input_profils, input_store } = this.state;
    return !(input_name.length > 0 && input_email.length > 0 && input_date_expiration.length > 0 && input_secretcode?.length > 0
      && input_password.length > 0 && input_profils.length > 0 && input_store.length > 0);
  }

  disableEditVendorButton() {
    const { input_name, input_email, input_date_expiration, input_secretcode, input_profils } = this.state;
    return !(input_name.length > 0 && input_email.length > 0 && input_date_expiration.length > 0 && input_secretcode?.length > 0 && input_profils.length > 0);
  }

  disableUserButton() {
    const { input_user_login, input_user_date_expiration, input_secretcode, input_profils } = this.state;
    return !(input_user_login.length > 0 && input_user_date_expiration.length > 0 && input_profils.length > 0 && input_secretcode.length > 0);
  }

  disableAddUserButton() {
    const { input_user_login, input_user_date_expiration, input_secretcode, input_password, input_profils } = this.state;
    return !(input_user_login.length > 0 && input_user_date_expiration.length > 0 && input_secretcode.length > 0 && input_password.length > 0 && input_profils.length > 0);
  }



  async setVendorDiscounts(id) {
    return new Promise((res, rej) => {
      bonitickAuthenticatedPostFetchWithResult('/bonification/vendorDiscounts/' + id, {}, (response, data) => {
        if (response === 200) {
          const vendorIndex = this.state.vendors.findIndex(v => v.id === Number(id));
          if (vendorIndex === -1) rej();
          const vendordiscount = [...this.state.vendors];
          vendordiscount[vendorIndex].discounts = data.discounts === undefined ? [] : data.discounts;
          this.setState({ vendors: vendordiscount });
          res();
        } else rej();
      });
    })
  }

  async editVendorDiscounts() {
    new Promise((resolve, reject) => {
      const list = this.state.input_discounts.map((discount) => {
        return discount.id;
      });
      bonitickAuthenticatedPutFetch('/bonification/vendorApply', {
        idVendor: this.state.editing,
        idDiscount: list,
      }, () => { resolve(); }, (e) => { this.showToaster(`Error :  ${e?.message}`, "danger", "error"); reject(e); });

    });
  }

  async setVendorParks(vendorId) {
    const vendorIndex = this.state.vendors.findIndex(v => v.id === vendorId);
    if (vendorIndex === -1) return;
    const vendorList = [...this.state.vendors];
    this.setState({ vendors: vendorList });
  }




  async updateCard() {
    const vendors = await getVendorLookup();
    const profils = await getProfilLookup();
    this.setState({ vendors, profils });
  }


  async getUser(id) {
    return new Promise((resolve, reject) => {
      bonitickAuthenticatedPostFetchWithResult('/bonification/user/' + id, {}, async (response, data) => {
        if (response === 200) {
          const user = [data.user];
          user.push(data.user);
          this.setState({
            input_user_login: user[0].login,
            input_user_date_expiration: user[0].dateExpiration,
            input_user_active: user[0].active,
            input_user_id: user[0].id,
            users: user,
          });
          resolve();
        }
        else {
          reject();
        }
      }, (e) => { this.showToaster(`Error :  ${e?.message}`, "danger", "error"); reject(e); });
    });
  }



  async componentDidMount() {
    this.showLoadingSpinner();
    await this.updateCard();
    this.setState({ loading: false, isOpen: Object.keys(this.state.vendors).map((_vendor) => false) });
  }

  toasterRef = React.createRef();

  showToaster(msg, intent, icon) {
    this.toasterRef.current?.show({
      message: msg,
      intent: intent,
      icon: icon
    });
  }

  showLoadingSpinner() {
    return (
      this.state.loading && (
        <Spinner intent="primary" size={Spinner.SIZE_STANDARD} />
      )
    );
  }

  editVendor() {
    const vendor = {
      id: this.state.editing,
      email: this.state.input_email,
      store: this.state.input_store,
      name: this.state.input_name,
      dateExpiration: this.state.input_date_expiration,
      admin: this.state.input_isadmin ? this.state.input_isadmin : false,
      active: this.state.input_active ? this.state.input_active : true,
      secretcode: this.state.input_secretcode,
      profil: this.state.input_profils[0]?.id
    };

    bonitickAuthenticatedPatchFetch(
      '/bonification/vendor',
      vendor,
      () => {
        const vendorIndex = this.state.vendors.findIndex((v) => { return v.id === this.state.editing; });
        if (vendorIndex !== -1) {
          const vendors = [...this.state.vendors];
          vendors[vendorIndex] = { ...vendors[vendorIndex], ...vendor, profil: this.state.input_profils[0] };
          localStorage.setItem('vendorLookup', JSON.stringify(vendors));
          this.showToaster("Vendor updated successfully.", "success", "tick");
          this.setState({ vendors, editing: -1 });
        }
      },
      (error) => {
        this.setState({ creating_error: true }, this.showToaster(`Error :  ${error?.message}`, "danger", "error"));
      });
  }


  getVendorById(id, vendorList) {
    const vendorIndex = vendorList.findIndex(v => v.id === id);
    if (vendorIndex === -1) return undefined;
    return vendorList[vendorIndex];
  }

  getProfilId(label) {
    const vendorIndex = this.state.profils.findIndex(v => v.label === label);
    if (vendorIndex === -1) return undefined;
    return this.state.profils[vendorIndex].id;
  }

  createVendor() {

    const vendor = {
      name: this.state.input_name,
      password: this.state.input_password,
      email: this.state.input_email,
      store: this.state.input_store,
      secretcode: this.state.input_secretcode,
      dateExpiration: this.state.input_date_expiration,
      admin: this.state.input_isadmin,
      profil: this.state.input_profils[0]?.id

    };

    bonitickAuthenticatedPostFetchWithResult('/bonification/vendor', vendor,
      (status, data) => {
        const vendors = [...this.state.vendors];
        vendors.push({ ...vendor, id: data.vendor.id, profil: this.state.input_profils[0] });
        localStorage.setItem('vendorLookup', JSON.stringify(vendors))
        this.showToaster("Vendor created successfully.", "success", "tick");
        this.setState({ vendors, creating: false });
      },
      (e) => {
        this.setState({ creating_error: true });
        this.showToaster(`Error :  ${e?.message}`, "danger", "error");
      });

  }


  createUser() {
    return new Promise((res, rej) => {
      const user = {
        login: this.state.input_user_login,
        password: this.state.input_password,
        secretcode: this.state.input_secretcode,
        idVendor: this.state.creating_vendor_id,
        idProfil: this.state.input_profils[0]?.id,
        dateExpiration: this.state.input_user_date_expiration,
        active: true,
      };
      bonitickAuthenticatedPostFetchWithResult(
        '/bonification/user',
        user,
        (status, data) => {
          const index = this.state.vendors.findIndex(u => { return u.id === this.state.creating_vendor_id });
          if (index !== -1) {
            const vendors = [...this.state.vendors];
            vendors[index].users = vendors[index].users || [];
            vendors[index].users.push({ ...user, id: data.user.id, profil: this.getProfil(user.idProfil) });
            localStorage.setItem('vendorLookup', JSON.stringify(vendors));
            this.setState({ vendors, creating_user: false, creating_error: false },
              async () => { await this.updateCard(); this.showToaster("User created successfully.", "success", "tick"); res(); });
          }
        },

        (e) => { this.setState({ creating_error: true }); this.showToaster(`Error :  ${e?.message}`, "danger", "error") }
      );
    }
    );

  }

  updateUser() {
    return new Promise((res, rj) => {
      const user = {
        id: this.state.editing_user,
        login: this.state.input_user_login,
        secretcode: this.state.input_secretcode,
        idVendor: this.state.input_user_vendorId,
        idProfil: this.state.input_profils[0]?.id,
        dateExpiration: this.state.input_user_date_expiration,
        active: this.state.input_user_active,
      };
      bonitickAuthenticatedPatchFetch(
        '/bonification/user', user
        , () => {
          const vendors = [...this.state.vendors];
          vendors.forEach(v => {
            v.users.forEach(u => {
              if (u.id === this.state.editing_user) {
                u.login = user.login;
                u.active = user.active;
                u.dateExpiration = user.dateExpiration;
                u.idProfil = user.idProfil;
                u.profil = this.getProfil(user.idProfil);
                u.secretcode = user.secretcode;
              }
            });
          });
          this.showToaster("User updated successfully.", "success", "tick");
          this.setState({ editing_user: -1, creating_error: false, vendors })
        },
        (error) => { this.setState({ creating_error: true }); this.showToaster(`Error :  ${error?.message}`, "danger", "error") }
      );
    });
  }

  getProfil(id) {
    return this.state.profils.find(p => p.id === id);
  }

  editUser(vendorId, userId) {
    const vendor = this.state.vendors.find(v => v.id === vendorId);
    if (vendor) {
      const user = vendor.users.find(u => u.id === userId);
      if (user) {
        if (!user.profil)
          user.profil = this.getProfil(user.idProfil);
        this.setState({
          editing_user: userId,
          input_user_vendorId: vendorId,
          input_user_login: user.login,
          input_user_date_expiration: user.dateExpiration,
          input_user_active: user.active,
          input_user_id: user.id,
          input_secretcode: user.secretcode,
          input_profils: [user.profil],
          users: user
        });
      }
    }
  }

  async removeUser() {
    return new Promise((res, rej) => {
      bonitickAuthenticatedDeleteFetch(
        '/bonification/user/' + this.state.editing_user, {},
        () => {
          let vendorIndex = -1;
          let userIndex = -1;
          const vendors = [...this.state.vendors];
          vendors.forEach(((v, vIndex) => {
            v.users.forEach((u, uIndex) => {
              if (u.id === this.state.editing_user) {
                vendorIndex = vIndex;
                userIndex = uIndex;
              }
            })
          }));
          if (vendorIndex !== -1) {
            vendors[vendorIndex].users.splice(userIndex, 1);
          }
          this.showToaster("User deleted successfully.", "success", "tick");
          this.setState({ vendors, editing_user: -1, creating_error: false })
        },
        (error) => { this.setState({ creating_error: true }); this.showToaster(`Error :  ${error?.message}`, "danger", "error") });
    });

  }

  render() {
    const vendors = [];

    for (const vendor of this.state.vendors) {
      vendors.push(
        <Callout title={<span>{vendor.name}<Button
          icon="edit"
          onClick={() => {
            this.setState({
              editing: vendor.id,
              input_name: vendor.name,
              input_email: vendor.email,
              input_active: vendor.active,
              input_store: vendor.store,
              input_secretcode: vendor.secretcode,
              input_isadmin: vendor.admin,
              input_date_expiration: vendor.dateExpiration,
              input_profils: [vendor.profil],
            });
          }}
        /></span>} key={`gr ${vendor.id}`}>
          <Button icon={this.state.isOpen[vendor.id] ? "chevron-down" : "chevron-right"} onClick={() => {
            this.setState({ isOpen: { ...this.state.isOpen, [vendor.id]: !this.state.isOpen[vendor.id] } });
          }} />
          <Collapse
            isOpen={this.state.isOpen[vendor.id] === true}
            onClose={() =>
              this.setState({ isOpen: { ...this.state.isOpen, [vendor.id]: false } })
            }
          >
            <Callout title={<Trans>Retailer's profile</Trans>}>
              {vendor.profil &&
                <Tag
                  intent="primary"
                  key={`profil_${vendor.profil?.id}_${vendor.profil?.active}`}
                > {vendor.profil?.label}</Tag>
              }
            </Callout>


            <Callout title={<span><Trans>users</Trans><Button
              icon="add"
              text={i18n.t("add")}
              onClick={() =>
                this.setState({
                  creating_user: true,
                  creating_vendor_id: vendor.id,
                  input_profils: [],
                  input_user_date_expiration: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
                })}
            /></span>}>
              {vendor.users?.map((user, index) => (
                <Button
                  key={`vendor_${vendor.id}_user_${user.id}`}
                  disabled={!user.profil?.active}
                  onClick={async () => {
                    this.editUser(vendor.id, user.id);
                  }}
                >{user.login}

                  <p>
                    <Tag intent="primary">{user.profil?.label}</Tag>
                  </p>
                </Button>
              ))}
            </Callout>
          </Collapse >
        </Callout >
      )
    }



    return <Callout title={<Trans>vendors</Trans>}>
      <Button icon="add" text={i18n.t("add")} onClick={async () => {
        const profils = await getProfilLookup();
        this.setState({
          creating: true,
          profils,
          input_profils: [],
          input_date_expiration: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
        })
      }} />
      {/* creating dialog */}
      <Dialog
        style={{ transition: 'none' }}
        isOpen={this.state.creating}
        onClose={() => this.setState({ creating: false, creating_error: false })}
        title={<Trans>add a vendor</Trans>}
      >
        <div className={Classes.DIALOG_BODY}>
          <form onSubmit={async e => {
            e.preventDefault(); // to avoid reload of the page on submit
          }}>
            <FormGroup label={<Trans>name</Trans>} labelFor="input_name">
              <InputGroup id="input_name"
                leftIcon="label"
                large={true}
                onChange={(ti) => this.setState({ input_name: ti.target.value })}
              />
            </FormGroup>

            <FormGroup label={<Trans>email</Trans>} labelFor="input_email">
              <InputGroup id="input_email"
                leftIcon="envelope"
                large={true}
                onChange={(ti) => this.setState({ input_email: ti.target.value })}
              />
            </FormGroup>

            <FormGroup label={<Trans>shop sign</Trans>} labelFor="input_store">
              <InputGroup id="input_store"
                leftIcon="shop"
                large={true}
                onChange={(ti) => this.setState({ input_store: ti.target.value })}
              />
            </FormGroup>

            <FormGroup label={<Trans>secret code</Trans>} labelFor="input_secretcode">
              <InputGroup id="input_secretcode"
                leftIcon="barcode"
                large={true}
                onChange={(ti) => this.setState({ input_secretcode: ti.target.value })}
              />
            </FormGroup>

            <FormGroup label={<Trans>password</Trans>} labelFor="input_password">
              <InputGroup id="input_password"
                leftIcon="key"
                large={true}
                onChange={(ti) => this.setState({ input_password: ti.target.value })}
                type="password"
              />
            </FormGroup>

            <FormGroup label={<Trans>profil</Trans>} labelFor="input_profils">
              <MultiSelect id="input_profils"
                items={this.state.profils}
                itemRenderer={(val, itemProps) => (
                  <MenuItem
                    key={val.id}
                    text={val.label}
                    disabled={this.state.input_profils.filter((i) => i.id === val.id).length === 1 ? true : false}
                    onClick={(elm) => {
                      this.setState({ input_profils: [val] });
                    }}

                  />
                )}
                tagRenderer={(item) => item}
                onItemSelect={() => { }}
                onRemove={(item) => {
                  this.setState({ input_profils: [] });
                }}
                tagInputProps={{
                  onRemove: (_i) =>
                    this.setState({ input_profils: this.state.input_profils.filter((i) => i.label !== _i) })
                }}
                selectedItems={this.state.input_profils?.map((discount) => discount?.label)}
              />
            </FormGroup>

            <FormGroup label={<Trans>expiration date</Trans>} labelFor='input_date_expiration'>
              <InputGroup id="input_date_expiration"
                leftIcon="outdated"
                large={true}
                onChange={(ti) => this.setState({ input_date_expiration: ti.target.value })}
                type="date"
                value={this.state.input_date_expiration}
              />
            </FormGroup>

            <FormGroup label={<Trans>admin</Trans>} labelFor="input_isadmin">
              <Checkbox id="input_isadmin"
                onChange={(ti) => this.setState({ input_isadmin: ti.target.checked })}
                checked={this.state.input_isadmin}
                large={true}
              />
            </FormGroup>

            <div className="flexbox-center">
              <FormGroup>
                <Button
                  text={<Trans>add</Trans>}
                  intent="primary"
                  type="submit"
                  icon="add"
                  onClick={() => this.createVendor()}
                  disabled={this.disableCreateVendorButton() || this.state.input_password.length === 0}
                />
                <Button
                  text={<Trans>cancel</Trans>}
                  intent="warning"
                  icon="undo"
                  style={{ marginLeft: '5px' }}
                  onClick={() => this.setState({ creating: false })}
                />
              </FormGroup>
            </div>

          </form>
        </div>
      </Dialog>
      {vendors}

      {/* editing vendor dialog */}
      {
        this.state.editing > -1 &&
        <Dialog
          style={{ transition: 'none' }}
          isOpen={this.state.editing >= 0}
          onClose={() => this.setState({ editing: -1, creating_error: false })}
          title={<Trans>edit vendor</Trans>}
        >
          <div className={Classes.DIALOG_BODY}>
            <form onSubmit={async (e) => {
              e.preventDefault();
              await this.editVendor();
            }}>
              <FormGroup label={<Trans>name</Trans>} labelFor="input_name">
                <InputGroup id="input_name" intent={this.state.creating_error ? "danger" : "normal"}
                  onChange={(ti) => this.setState({ input_name: ti.target.value })}
                  leftIcon="label"
                  large={true}
                  value={this.state.input_name}
                />
              </FormGroup>

              <FormGroup label={<Trans>email</Trans>} labelFor="input_email">
                <InputGroup id="input_email" intent={this.state.creating_error ? "danger" : "normal"}
                  onChange={(ti) => this.setState({ input_email: ti.target.value })}
                  leftIcon="envelope"
                  large={true}
                  value={this.state.input_email}
                />
              </FormGroup>

              <FormGroup label={<Trans>shop sign</Trans>} labelFor="input_store">
                <InputGroup id="input_store" intent={this.state.creating_error ? "danger" : "normal"}
                  onChange={(ti) => this.setState({ input_store: ti.target.value })}
                  value={this.state.input_store}
                  leftIcon="shop"
                  large={true}
                />
              </FormGroup>

              <FormGroup label={<Trans>secret code</Trans>} labelFor="input_secretcode">
                <InputGroup id="input_secretcode" intent={this.state.creating_error ? "danger" : "normal"}
                  onChange={(ti) => this.setState({ input_secretcode: ti.target.value })}
                  value={this.state.input_secretcode}
                  leftIcon="barcode"
                  large={true}
                />
              </FormGroup>

              <FormGroup label={<Trans>profil</Trans>} labelFor="input_profils">
                <MultiSelect id="input_profils"
                  items={this.state.profils}
                  itemRenderer={(val, itemProps) => (
                    <MenuItem
                      key={val.id}
                      text={val.label}
                      disabled={this.state.input_profils.filter((i) => i?.id === val?.id)?.length === 1 ? true : false}
                      onClick={(elm) => {
                        this.setState({ input_profils: [val] });
                      }}

                    />
                  )}
                  tagRenderer={(item) => item}
                  onItemSelect={() => { }}
                  onRemove={(item) => {
                  }}
                  tagInputProps={{ onRemove: (_i) => this.setState({ input_profils: [] }) }}
                  selectedItems={this.state.input_profils?.map((discount) => discount?.label)}
                />
              </FormGroup>


              <FormGroup label={<Trans>expiration date</Trans>} labelFor='input_date_expiration'>
                <InputGroup id="input_date_expiration"
                  onChange={(ti) => this.setState({ input_date_expiration: ti.target.value })}
                  type="date"
                  value={this.state.input_date_expiration}
                  leftIcon="outdated"
                  large={true}
                />
              </FormGroup>

              <FormGroup label={<Trans>admin</Trans>} labelFor="input_isadmin">
                <Checkbox id="input_isadmin"
                  onChange={(ti) => this.setState({ input_isadmin: ti.target.checked })}
                  checked={this.state.input_isadmin}
                  large={true}
                />
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    text={<Trans>edit</Trans>}
                    intent="primary"
                    icon="edit"
                    disabled={this.disableEditVendorButton()}
                    onClick={async () => await this.editVendor()}
                  />
                  <Button
                    text={<Trans>cancel</Trans>}
                    intent="warning"
                    icon="undo"
                    style={{ marginLeft: '5px' }}
                    onClick={() => this.setState({ editing: -1, creating_error: false })}
                  />

                  <Button
                    text={<Trans>delete</Trans>}
                    intent="danger"
                    icon="cross"
                    style={{ marginLeft: '5px' }}
                    onClick={() => {
                      bonitickAuthenticatedDeleteFetch(
                        '/bonification/vendor/' + this.state.editing,
                        {},
                        () => {
                          let vendors = [...this.state.vendors];
                          const index = vendors.findIndex(v => { return v.id === this.state.editing });
                          if (index > -1) {
                            vendors.splice(index, 1);
                            localStorage.setItem('vendorLookup', JSON.stringify(vendors));
                          }
                          this.setState({ vendors, editing: -1, creating_error: false },
                            async () => { await this.updateCard(); this.showToaster("Vendor deleted successfully.", "success", "tick") });
                        },
                        (error) => { this.setState({ creating_error: true }); this.showToaster(`Error :  ${error?.message}`, "danger", "error") });
                    }}
                  />
                </FormGroup>
              </div>
            </form>
          </div>
        </Dialog>
      }

      {/* creating user dialog */}
      <Dialog
        style={{ transition: 'none' }}
        isOpen={this.state.creating_user}
        onClose={() => this.setState({ creating_user: false, creating_error: false })}
        title={<Trans>add a user</Trans>}
      >
        <div className={Classes.DIALOG_BODY}>
          <form onSubmit={e => {
            e.preventDefault(); // to avoid reload of the page on submit
            this.createUser();
          }}>
            <FormGroup label={<Trans>login</Trans>} labelFor="input_name">
              <InputGroup id="input_name"
                leftIcon="label"
                large={true}
                onChange={(ti) => this.setState({ input_user_login: ti.target.value })}
              />
            </FormGroup>

            <FormGroup label={<Trans>password</Trans>} labelFor="input_password">
              <InputGroup id="input_password"
                onChange={(ti) => this.setState({ input_password: ti.target.value })}
                type="password"
                leftIcon="key"
                large={true}
              />
            </FormGroup>


            <FormGroup label={<Trans>secret code</Trans>} labelFor="input_secretcode">
              <InputGroup id="input_secretcode"
                onChange={(ti) => this.setState({ input_secretcode: ti.target.value })}
                leftIcon="barcode"
                large={true}
              />
            </FormGroup>


            <FormGroup label={<Trans>profil</Trans>} labelFor="input_profils">
              <MultiSelect id="input_profils"
                items={this.state.profils}
                itemRenderer={(val, itemProps) => (
                  <MenuItem
                    key={val.id}
                    text={val.label}
                    disabled={this.state.input_profils.filter((i) => i.id === val.id).length === 1 ? true : false}
                    onClick={(elm) => {
                      this.setState({ input_profils: [val] });
                    }}

                  />
                )}
                tagRenderer={(item) => item}
                onItemSelect={() => { }}
                onRemove={(item) => {
                  //TODO manage Remove
                }}
                tagInputProps={{ onRemove: (_i) => this.setState({ input_profils: this.state.input_profils.filter((i) => i !== _i) }) }}
                selectedItems={this.state.input_profils?.map((discount) => discount?.label)}
              />
            </FormGroup>

            <FormGroup label={<Trans>expiration date</Trans>} labelFor='input_user_date_expiration'>
              <InputGroup id="input_user_date_expiration"
                onChange={(ti) => this.setState({ input_user_date_expiration: ti.target.value })}
                type="date"
                leftIcon="outdated"
                large={true}
                value={this.state.input_user_date_expiration}
              />
            </FormGroup>


            <div className="flexbox-center">
              <FormGroup>
                <Button
                  text={<Trans>add</Trans>}
                  intent="primary"
                  type="submit"
                  icon="add"
                  disabled={(this.disableAddUserButton() || this.state.input_password.length === 0)}
                />
                <Button
                  text={<Trans>cancel</Trans>}
                  intent="warning"
                  icon="undo"
                  style={{ marginLeft: '5px' }}
                  onClick={() => this.setState({ creating_user: false })}
                />
              </FormGroup>
            </div>
          </form>
        </div>
      </Dialog>

      {/* editing user dialog */}
      {
        this.state.editing_user > -1 &&
        <Dialog
          style={{ transition: 'none' }}
          isOpen={this.state.editing_user > -1}
          onClose={() => this.setState({ editing_user: -1, creating_error: false })}
          title={<Trans>edit user</Trans>}
        >
          <div className={Classes.DIALOG_BODY}>
            <form onSubmit={(e) => {
              e.preventDefault();
              this.updateUser();
            }
            }>
              <FormGroup label={<Trans>login</Trans>} labelFor="input_user_login">
                <InputGroup id="input_user_login" intent={"normal"}
                  onChange={(ti) => this.setState({ input_user_login: ti.target.value })}
                  value={this.state.input_user_login}
                  leftIcon="label"
                  large={true}
                />
              </FormGroup>

              <FormGroup label={<Trans>secret code</Trans>} labelFor='input_secretcode'>
                <InputGroup id="input_secretcode"
                  onChange={(ti) => this.setState({ input_secretcode: ti.target.value })}
                  value={this.state.input_secretcode}
                  leftIcon="barcode"
                  large={true}
                />
              </FormGroup>

              <FormGroup label={<Trans>profil</Trans>} labelFor="input_profils">
                <MultiSelect id="input_profils"
                  items={this.state.profils}
                  itemRenderer={(val, itemProps) => (
                    <MenuItem
                      key={val.id}
                      text={val.label}
                      disabled={this.state.input_profils.filter((i) => i.id === val.id).length === 1 ? true : false}
                      onClick={(elm) => {
                        this.setState({ input_profils: [val] });
                      }}

                    />
                  )}
                  tagRenderer={(item) => item}
                  onItemSelect={() => { }}
                  onRemove={(item) => {
                    this.setState({ input_profils: [] });
                  }}
                  tagInputProps={{ onRemove: (_i) => this.setState({ input_profils: [] }) }}
                  selectedItems={this.state.input_profils?.map((discount) => discount?.label)}
                />
              </FormGroup>


              <FormGroup label={<Trans>expiration date</Trans>} labelFor='input_user_date_expiration'>
                <InputGroup id="input_user_date_expiration"
                  onChange={(ti) => this.setState({ input_user_date_expiration: ti.target.value })}
                  type="date"
                  leftIcon="outdated"
                  large={true}
                  value={this.state.input_user_date_expiration}
                />
              </FormGroup>

              <div className="flexbox-center">
                <FormGroup>
                  <Button
                    text={<Trans>edit</Trans>}
                    intent="primary"
                    icon="edit"
                    disabled={this.disableUserButton()}
                  />
                  <Button
                    text={<Trans>cancel</Trans>}
                    intent="warning"
                    icon="undo"
                    style={{ marginLeft: '5px' }}
                    onClick={() => this.setState({ editing_user: -1, creating_error: false })}
                  />

                  <Button
                    text={<Trans>delete</Trans>}
                    intent="danger"
                    icon="cross"
                    style={{ marginLeft: '5px' }}
                    onClick={async () => {
                      await this.removeUser();
                    }}
                  />
                </FormGroup>
              </div>
            </form>
          </div>
        </Dialog>
      }
      <OverlayToaster className={Classes.TOAST_CONTAINER} usePortal={true} ref={this.toasterRef} position={Position.RIGHT_BOTTOM} />


    </Callout >
  }

}

export default Vendor;
